import React, { Component } from "react";
import Desplegable from "../../desplegable";
import VistaDatosFamiliares from "../vistas/vista_familiares";
import FormDatosFamiliares from "../formularios/form_familiares";

export default class DesplegableFamiliares extends Component {
  render() {
    return (
      <Desplegable
        eventKey="10"
        id="10"
        handleButtonShow={this.props.handleButtonShow}
        showModal={this.props.state.showModalMatrix[10]}
        Toogle={"Datos Familiares"}
        Text={<VistaDatosFamiliares DatosMonja={this.props.state.DatosUsuario}></VistaDatosFamiliares>}
        Form={
          <FormDatosFamiliares
            DatosMonja={this.props.state.DatosUsuario}
            setDatosHermana={this.props.setDatosHermana}
            handleButtonShow={this.props.handleButtonShow}
            setAlert={this.props.setAlert}
            ErrorHandling={this.props.ErrorHandling}
          ></FormDatosFamiliares>
        }
        canEdit={true}
      />
    );
  }
}
